/* ============================================================
   ILS landing interactions
   - scroll-scrubbed washing-machine drum (+ speed blur + suds)
   - parts fly-in / assembly scene
   - reveal-on-scroll for content sections
   ============================================================ */
(function () {
  if (window.__ilsLandingInit) return;
  window.__ilsLandingInit = true;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smoothstep(t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }

  function progressOf(track) {
    var rect = track.getBoundingClientRect();
    var vh = window.innerHeight;
    var total = track.offsetHeight - vh;
    var scrolled = clamp(-rect.top, 0, total > 0 ? total : 0);
    return total > 0 ? scrolled / total : 0;
  }

  function init() {
    setupScrollMachine();
    setupAssembly();
    setupDryer();
    setupHeaderScroll();
    setupReveal();
  }

  /* ---- shrinking sticky header: add a class to <body> once scrolled ---- */
  function setupHeaderScroll() {
    var last = null;
    function onScroll() {
      var s = window.scrollY > 40;
      if (s !== last) { document.body.classList.toggle('ils-scrolled', s); last = s; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- spinning drum ---- */
  function setupScrollMachine() {
    var sections = document.querySelectorAll('.ils-scroll');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('.ils-scroll__track');
      var stage = section.querySelector('.ils-stage');
      var drum = section.querySelector('.ils-drum');
      var blur = section.querySelector('.ils-drum-blur');
      var suds = section.querySelector('.ils-suds');
      var features = section.querySelectorAll('.ils-feature');
      var dots = section.querySelectorAll('.ils-dots span');
      if (!track || !stage) return;

      var ticking = false, prev = 0, vel = 0, blurTimer = null;

      function render() {
        ticking = false;
        var progress = progressOf(track);
        stage.style.setProperty('--p', progress.toFixed(4));

        var delta = Math.abs(progress - prev);
        prev = progress;
        vel += (delta - vel) * 0.35;

        if (drum && !reduceMotion) {
          drum.setAttribute('transform', 'rotate(' + (progress * 1080).toFixed(2) + ' 300 300)');
        }
        if (blur && !reduceMotion) {
          blur.setAttribute('stdDeviation', Math.min(3.5, vel * 240).toFixed(2));
          if (blurTimer) clearTimeout(blurTimer);
          blurTimer = setTimeout(function () { blur.setAttribute('stdDeviation', '0'); }, 150);
        }
        if (suds) {
          suds.style.opacity = clamp(4 * progress * (1 - progress), 0, 0.95).toFixed(3);
        }
        if (features.length) {
          var idx = Math.min(features.length - 1, Math.floor(progress * features.length + 0.0001));
          if (progress <= 0) idx = 0;
          for (var i = 0; i < features.length; i++) features[i].classList.toggle('is-active', i === idx);
          for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);
        }
      }

      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      render();

      if (reduceMotion && features.length) {
        features[0].classList.add('is-active');
        if (dots.length) dots[0].classList.add('is-active');
      }
    });
  }

  /* ---- parts fly-in assembly ---- */
  function setupAssembly() {
    var sections = document.querySelectorAll('.ils-assembly');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('.ils-asm-track');
      var stage = section.querySelector('.ils-asm-stage');
      var parts = section.querySelectorAll('.ils-part');
      if (!track) return;

      var ticking = false;

      function render() {
        ticking = false;
        var p = progressOf(track);
        if (stage) stage.style.setProperty('--p', p.toFixed(4));

        for (var i = 0; i < parts.length; i++) {
          var el = parts[i];
          var s = parseFloat(el.getAttribute('data-start')) || 0;
          var e = parseFloat(el.getAttribute('data-end')) || 1;
          var t = reduceMotion ? 1 : smoothstep((p - s) / ((e - s) || 1));
          var fx = parseFloat(el.getAttribute('data-fx')) || 0;
          var fy = parseFloat(el.getAttribute('data-fy')) || 0;
          var fr = parseFloat(el.getAttribute('data-frot')) || 0;
          var sc = 0.55 + 0.45 * t;
          el.style.transform =
            'translate(' + (fx * (1 - t)).toFixed(1) + 'px,' + (fy * (1 - t)).toFixed(1) + 'px)' +
            ' rotate(' + (fr * (1 - t)).toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
          el.style.opacity = Math.min(1, t * 1.4).toFixed(3);
        }
      }

      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      render();
    });
  }

  /* ---- tumble dryer: headings tumble up through a spinning drum ---- */
  function setupDryer() {
    var sections = document.querySelectorAll('.ils-dryer');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('.ils-dryer__track');
      var stage = section.querySelector('.ils-dryer__stage');
      var drum = section.querySelector('.ils-dryer__drum');
      var words = section.querySelectorAll('.ils-dryer__word');
      if (!track) return;

      var ticking = false, n = words.length;

      function render() {
        ticking = false;
        var p = progressOf(track);
        if (stage) stage.style.setProperty('--p', p.toFixed(4));
        if (drum && !reduceMotion) {
          drum.setAttribute('transform', 'rotate(' + (p * 900).toFixed(2) + ' 300 330)');
        }
        if (!n) return;

        for (var i = 0; i < n; i++) {
          var w = words[i];
          if (reduceMotion) {
            w.style.opacity = i === 0 ? '1' : '0';
            w.style.transform = 'none';
            continue;
          }
          var span = 1 / (n + 0.2);
          var center = (i + 0.6) * span;
          var d = (p - center) / span;              // 0 at centre, <0 before, >0 after
          var vis = 1 - Math.min(1, Math.abs(d) / 0.9);
          w.style.opacity = (vis * vis).toFixed(3);
          var ty = (-d * 72).toFixed(1);            // rise from below, up through, out the top
          var rot = (-d * 16).toFixed(1);
          var sc = (0.7 + 0.3 * vis).toFixed(3);
          w.style.transform = 'translateY(' + ty + 'px) rotate(' + rot + 'deg) scale(' + sc + ')';
        }
      }

      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      render();
    });
  }

  /* ---- reveal on scroll ---- */
  function setupReveal() {
    var items = document.querySelectorAll('.ils-reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
